export default __webpack_public_path__ + "16536cb8e4578dd22f8856a3be220362.wasm";